import CartDrawer from "../components/CartDrawer";
import Excerpts from "../components/Excerpts";
import Faq from "../components/Faq";
import FinalCta from "../components/FinalCta";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import InsideArchive from "../components/InsideArchive";
import Marquee from "../components/Marquee";
import Navbar from "../components/Navbar";
import StickyBuyBar from "../components/StickyBuyBar";
import Testimonials from "../components/Testimonials";

const Landing = () => (
  <div className="grain" data-testid="landing-page">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Excerpts />
      <InsideArchive />
      <Testimonials />
      <Faq />
      <FinalCta />
    </main>
    <Footer />
    <CartDrawer />
    <StickyBuyBar />
    <div className="h-16 sm:hidden" />
  </div>
);

export default Landing;
